import React from 'react';
import notificationComponents, { NotificationComponents } from './renderers';
import Unknown from './renderers/unknown';
import { Notification } from '../types/Notification';

interface NotificationRendererProps {
  notification: Notification;
  registerRefetch?: (refetchFn: () => void) => () => void;
}

const NotificationRenderer = ({ notification, registerRefetch }: NotificationRendererProps) => {
  const { subject_type } = notification;

  const NotificationComponent = notificationComponents[subject_type as keyof NotificationComponents];

  if (!NotificationComponent) {
    return <Unknown notification={notification} />
  }
  return (
    <NotificationComponent notification={notification} registerRefetch={registerRefetch} />
  );
};

export default NotificationRenderer;
